import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { dateConversion, stringToTime, getDateBetween, paramsEncode } from '../../../utils';
import Urls from '../../../../config';
const getDownloadUrl = Urls.TaskStatisticUrl.exportData;
import { getIndexList } from './actions';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';

class ExportData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taskId: undefined, //任务id
            adId:undefined,//广告Id
            ps:undefined,//广告位编号
            beginDate: undefined, //开始时间
            endDate: undefined, //结束时间
            downloadUrl: getDownloadUrl,
            type:0,//聚合类型
            taskDescription: undefined,//订单名称
            taskName: undefined//任务名称
        };
    }

    componentDidMount() {
        // this.props.getIndexList(); //查询操作日志
    }
    async changeTaskDescription(taskDescription) {
      console.log(this.state);
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: taskDescription.target.value,
            taskName: this.state.taskName
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskDescription: taskDescription.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeTaskName(taskName) {
      console.log(this.state);
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: this.state.taskDescription,
            taskName: taskName.target.value
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskName: taskName.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeTaskId(id) {
      console.log(this.state);
        let paramStr = '';
        const param = {
            taskId: id.target.value, //任务id
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: this.state.taskDescription,
            taskName: this.state.taskName
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskId: id.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeAdId(id) {
      let paramStr = '';
      const param = {
          taskId: this.state.taskId, //任务id
          adId:id.target.value,//广告Id
          ps:this.state.ps,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
      };
      paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          adId: id.target.value,
          downloadUrl: paramStr,
      });
    }
    async changePs(id) {
      let paramStr = '';
      const param = {
          taskId: this.state.taskId, //任务id
          adId:this.state.adId,//广告Id
          ps:id.target.value,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
      };
      paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          ps: id.target.value,
          downloadUrl: paramStr,
      });
    }
    async changeType(id) {
      let paramStr = '';
      const param = {
          taskId: this.state.taskId, //任务id
          adId:this.state.adId,//广告Id
          ps:this.state.ps,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: id.target.value,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskDescription
      };
      paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          type: id.target.value,
          downloadUrl: paramStr,
      });
    }
    async changeData(a, b) {
        let paramStr = '';
        const param = {
          taskId: this.state.taskId, //任务id
          adId:this.state.adId,//广告Id
          ps:this.state.ps,//广告位编号
          beginDate: b[0], //开始时间
          endDate: b[1], //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            beginDate: b[0],
            endDate: b[1],
            downloadUrl: paramStr,
        });
    }
    async download(){
        if(this.state.beginDate == undefined || this.state.beginDate == undefined ||
            this.state.beginDate == null || this.state.beginDate == null ||
            this.state.beginDate == '' || this.state.beginDate == ''){
            message.info('请输入开始时间和结束时间!');
            return ;
        }
        //下载文件
        const aLink = document.createElement('a');
        document.body.appendChild(aLink);
        aLink.style.display='none';
        aLink.href = this.state.downloadUrl;
        aLink.download = "fileName";
        aLink.click();
        document.body.removeChild(aLink);
    }

    render() {
        // let columns = [
        //     {
        //         title: '数据',
        //         dataIndex: 'index',
        //         render: (text, record) => (
        //             <div>
        //                 {record}
        //             </div>
        //         ),
        //     }
        // ];
        const { loading,indexList } = this.props;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>数据导出</h2>

                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                    <label>
                        任务ID：
                        <Input placeholder="任务id" style={{ width: 120 }} onChange={this.changeTaskId.bind(this)} />
                    </label>
                    <label>
                        广告ID：
                        <Input placeholder="广告id" style={{ width: 120 }} onChange={this.changeAdId.bind(this)} />
                    </label>
                    <label>
                        订单名称：
                        <Input placeholder="订单名称" style={{ width: 120 }} onChange={this.changeTaskDescription.bind(this)} />
                    </label>
                    <label>
                        任务名称：
                        <Input placeholder="任务名称" style={{ width: 120 }} onChange={this.changeTaskName.bind(this)} />
                    </label>
                    <label>
                        PS：
                        <Input placeholder="ps" style={{ width: 120 }} onChange={this.changePs.bind(this)} />
                    </label>
                </div>

                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                    <label>
                        聚合维度：
                        <RadioGroup value={this.state.type} onChange={this.changeType.bind(this)}>
                            <RadioButton value={0}>天</RadioButton>
                            <RadioButton value={1}>小时</RadioButton>
                        </RadioGroup>
                    </label>
                    <label>
                        日期：
                        <RangePicker
                            format="YYYY-MM-DD"
                            onChange={(value, dateString) => this.changeData(value, dateString)}
                        />
                    </label>
                    <Button type="primary" style={{ float: 'right' }} onClick={this.download.bind(this)}>
                        {/*  <a href={this.state.downloadUrl} download="filename">
                            导出数据
                        </a>*/}
                        导出数据
                    </Button>
                </div>

                {/* <Spin spinning={loading} tip="加载中">
                    <Table columns={columns} dataSource={indexList} pagination={false} bordered />
                </Spin> */}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.index.ListStatus.loading,
    indexList: state.index.IndexList,
});

const mapDispatchToProps = dispatch => ({
    getIndexList: prarms => dispatch(getIndexList(prarms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportData);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/exportData/index.js